import ContactRelationTable from '@contacts/components/tables/contact-relation-table/contact-relation-table.vue';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'bpc-profile-family',
  components: {
    'bpc-contact-relation-table': ContactRelationTable,
  },
})
export default class ProfileFamily extends Vue {
  get contactId() {
    return this.$authorizationService.getContactId();
  }

  filterByContactId() {
    return [{ filterField: 'contact_id', modelField: null, value: this.contactId }];
  }

  public onNewContactRelation() {
    this.$router.push('family-form');
  }
  public onEditContactRelation($event) {
    this.$router.push('family-form/' + $event.item.id);
  }
  /* Lifecycle hooks */
  // created () { }
  // mounted () { }
  // updated () { }
  // destroyed () { }
}
